import { z } from "zod";

export const DTOObjectMeta = z.object({
  name: z.string().max(512),
  description: z.string().max(2048).optional(),
});

export type DTOObjectMeta = z.infer<typeof DTOObjectMeta>;
